import React from 'react';
import ReactDOMServer from 'react-dom/server';
import separator_line from "../assets/separator_line.png";
import VidyaUpasna from "../assets/VidyaUpasna.jpg";
import { getCurrentTime } from './CurrentTime';
import moment from 'moment';

const TeacherMappingList = ({ teacherMappingDetails }) => {
  return (
    <td>
      {teacherMappingDetails.map((details, index) => {
        const gradeName = details.instituteGradeMasterDetails.gradeName;
        const divisionName = details.instituteDivisionMasterDetails.divisionName;
        const subjectName = details.instituteSubjectMasterDetails.subjectName;
        return (
          <div key={index}>
            {gradeName} - {divisionName} - {subjectName}
          </div>
        );
      })}
    </td>
  );
};


export const GeneratePdf = ({ id, title, headerTitle, planList }) => {
  const exportToPdf = () => {
    const content = document.getElementById(id);
    if (content) {
      if (id === 'examReportContent') {
        let printWindowReportContent = window.open(' ', '_blank');
        // Write the HTML to the new window, including the content to print
        printWindowReportContent.document.write(`
          <html>
          <head>
          <style>
          @media print{
            .report_code {
              position: relative;
            }
            .report_code .line {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 0;
              width: 100%;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            table thead tr th,
            table tbody tr td,
            table tfoot tr th {
              padding: 8px;
              border: 1px solid #000;
              text-align: center;
              vertical-align: middle;
            }

            .exam_report table tbody tr td {
              color: #a80000;
            }

            .table_caption {
              display: block;
              text-align: center;
              font-weight: 600;
              margin: 16px 0;
            }

            .analysis_report table thead tr th,
            .analysis_report table tfoot tr th {
              color: #a80000;
            }

            .text_right {
              text-align: right;
            }

            .text_center {
              text-align: center;
            }

            .report_block .heading {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            .report_block .heading .logo {
              width: 100px;
            }

            .report_block .heading .logo img {
              max-width: 100%;
            }

            .report_block .report_code span.txt {
              display: inline-block;
              padding: 8px 20px;
              border-radius: 8px;
              border: 1px solid #000;
              background: #f1f1f1;
              position: relative;
              z-index: 1;
            }

            .report_block .report_head {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin: 32px 0;
              text-align: center;
            }

            .report_block .report_head span {
              display: block;
            }

            .report_block .report_footer {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              margin-top: 24px;
            }

            .report_block .report_footer div {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 16px;
            }

            .report_block .report_footer span {
              display: block;
              color: #a80000;
              font-weight: 500;
              text-align: center !important;
            }

            .candidate_details table tbody tr td {
              text-align: left;
              padding: 24px;
            }
          }
          </style>
          </head>
          <body>
          ${content.outerHTML}
          </body>
          </html>
        `);

        // Delay to ensure content is written before printing
        setTimeout(() => {
          printWindowReportContent.document.close(); // Close the document to complete the writing process
          printWindowReportContent.focus(); // Focus on the new window
          printWindowReportContent.print(); // Invoke the native print function
          printWindowReportContent.close(); // Close the print window after printing
        }, 250); // Adjust delay as needed
      } else if (id === 'AIBasedTeachingPlan') {
        const teachingPlan = title;
        const teachingPlanContent = (
          <div class="report_block">
            <div class="heading">
              <div class="logo">
                <img src={VidyaUpasna} alt="" />
              </div>
              <div class="text_center">
                <h4>Super Admin</h4>
              </div>
              <div class="logo">
                <img src={VidyaUpasna} alt="" />
              </div>
            </div>
            <div class="report_code text_center mb-3">
              <img src={separator_line} alt="" className="line" />
              <span className="txt">Teaching Plan</span>
            </div>

            <div class="report_head">
              <span>Syllabus Structure: {teachingPlan?.AiTeachingPlanSyllabusStructureMasterDetails?.syllabusStructureName}</span>
              <span>Subject: {teachingPlan?.subjectMasterDetails?.subjectName}</span>
              <span>Lesson Name: {teachingPlan?.AiTeachingPlanLessonMasterDetails?.lessonName}</span>
            </div>

            <div class="analysis_report schedule_table">
              {/* <span class="table_caption">Name of Report : Class Exam</span> */}
              <div className="page" dangerouslySetInnerHTML={{ __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${teachingPlan?.details}</div>` }} ></div>
            </div>

            <div class="report_footer">
              <div>
                <span>{getCurrentTime()}</span>
                <span>Time stamp of export</span>
              </div>
              <div>
                {/* <span>{teachingPlan[0]?.teacherMasterDetails?.teacherName}</span> */}
                <span>Supervisor Signature</span>
              </div>
              <div>
                {/* <span>{teachingPlan[0]?.teacherMasterDetails?.teacherName}</span> */}
                <span>Principle Signature</span>
              </div>
            </div>
          </div>
        )

        let printWindowTeachingPlanContent = window.open(' ', '_blank');

        printWindowTeachingPlanContent.document.write(`
          <html>
          <head>
          <style>
          @media print{
            .report_code {
              position: relative;
            }
            .report_code .line {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 0;
              width: 100%;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            table thead tr th,
            table tbody tr td,
            table tfoot tr th {
              padding: 8px;
              border: 1px solid #000;
              text-align: center;
              vertical-align: middle;
            }

            .exam_report table tbody tr td {
              color: #a80000;
            }

            .table_caption {
              display: block;
              text-align: center;
              font-weight: 600;
              margin: 16px 0;
            }

            .analysis_report table thead tr th,
            .analysis_report table tfoot tr th {
              color: #a80000;
            }

            .text_right {
              text-align: right;
            }

            .text_center {
              text-align: center;
            }

            .report_block .heading {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            .report_block .heading .logo {
              width: 100px;
            }

            .report_block .heading .logo img {
              max-width: 100%;
            }

            .report_block .report_code span.txt {
              display: inline-block;
              padding: 8px 20px;
              border-radius: 8px;
              border: 1px solid #000;
              background: #fff;
              position: relative;
              z-index: 1;
            }

            .report_block .report_head {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin: 32px 0;
              text-align: center;
            }

            .report_block .report_head span {
              display: block;
            }

            .report_block .report_footer {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              margin-top: 24px;
            }

            .report_block .report_footer div {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 16px;
            }

            .report_block .report_footer span {
              display: block;
              color: #a80000;
              font-weight: 500;
              text-align: center !important;
            }

            .candidate_details table tbody tr td {
              text-align: left;
              padding: 24px;
            }
          }
        
          </style>
          </head>
          <body>
          ${ReactDOMServer.renderToString(teachingPlanContent)}
          </body>
          </html>
        `);

        setTimeout(() => {
          printWindowTeachingPlanContent.document.close();
          printWindowTeachingPlanContent.focus();
          printWindowTeachingPlanContent.print();
          printWindowTeachingPlanContent.close();
        }, 250);
      } else if (id === 'tableContent') {
        const data = title
        const content = (
          <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Sr. No.</th>
                  <th scope="col">Name of Student</th>
                  <th scope="col">Gender</th>
                  <th scope="col">Blood Group</th>
                  <th scope="col">Contact No</th>
                  <th scope="col">E-mail</th>
                  <th scope="col">Address</th>
                </tr>
              </thead>
              <tbody>
                {
                  data?.length > 0 ?
                    data?.map((student, index) => {
                      return (
                        <>
                          <tr>
                            <th scope="row">{index + 1}</th>
                            <td>{student.studentName}</td>
                            <td>{student.gender}</td>
                            <td>{student?.bloodGroup}</td>
                            <td>{student?.primaryContact}, <br />{student?.secondaryContact}</td>
                            <td>{student?.email}</td>
                            <td>{student?.address}</td>
                          </tr>
                        </>
                      )
                    })
                    :
                    (<tr>
                      <th colspan={"100%"} style={{ textAlign: 'center' }}>No Student Available</th>
                    </tr>)
                }
              </tbody>
            </table>
          </div>
        )

        const newContent = `
          <div>
            <div class="heading">
              <div class="logo">
                ${data[0]?.instituteMasterDetails?.logoPath ?
            `<img src="${data[0]?.instituteMasterDetails?.logoPath}" alt="Logo" />` : ''
          }
              </div>
              <div class="text_center">
                <h6>${data[0]?.instituteMasterDetails?.instituteName}</h6>
                <h4>${data[0]?.sectionMasterDetails?.sectionName}</h4>
                <h3>${headerTitle}</h3>
              </div>
              <div class="logo">
                ${data[0]?.sectionMasterDetails?.logoPath ?
            `<img src="${data[0]?.sectionMasterDetails?.logoPath}" alt="Logo" />` : ''
          }
              </div>
            </div>
            ${ReactDOMServer.renderToString(content)}
          </div>
        `;

        let printWindowTableContent = window.open(' ', '_blank');

        printWindowTableContent.document.write(`
          <html>
          <head>
          <style>
            table thead tr th {
              background-color: #004580 !important;
              color: #fff !important;
              border-width: 1px;             
              padding: 10px;
              vertical-align: middle;
              border-color: #ddd;
              border-style: solid;
            } 

            table tbody tr td,
            table tbody tr th {              
              border-width: 1px;             
              padding: 10px;
              vertical-align: middle;
              border-color: #ddd;
              color: #73879c;
              border-style: solid;
            }
            
            table tr tbody td.sl_no, table tr thead th.sl_no {
                min-width: 50px;
                width: 50px;
            }   
            .row.exam-result-header {
              display: flex;
              gap: 10px;
              margin-bottom: 10px;
              align-items: center;
              justify-content: space-between;
            } 
            #tableContent button{
              display: none;
            }
            #tableContent h3 {
              text-align: center;
              margin-bottom: 20px;
            }
            #preview-1000 {
              display: flex;
              justify-content: center;
            }
            
            table {
              border-collapse: collapse;
              caption-side: bottom;
              width: 960px;
            }

            .heading {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              max-width: 920px;
              margin: 20px auto 0;
              background: #004580;
              color: #fff;
              padding: 20px;
              border-radius: 20px 20px 0 0;
            }

            // .heading h3{
            //   color: #fff;
            // }

            .heading .text_center h3 {
              font-size: 2.5em;
            }

            .heading .text_center h6, h4 {
              margin: 0;
              font-size: 1.5em;
            }

            .text_center {
              margin: 0;
              text-align: center;
              flex-grow: 1;
            }

            .heading .logo {
              width: 100px;
            }

            .heading .logo img {
              max-width: 100%;
              border-radius: 15px;
            }

            .heading-layout {
              display: flex;
              align-items: center;
              gap: 20px;
              justify-content: flex-start;
              width: 100%;
              max-width: 920px;
              margin: 20px auto 0;
              background: #004580;
              padding: 20px;
              border-radius: 20px 20px 0 0;
            }
          </style>
          </head>
          <body>
          ${newContent}
          </body>
          </html>
        `);

        setTimeout(() => {
          printWindowTableContent.document.close();
          printWindowTableContent.focus();
          printWindowTableContent.print();
          printWindowTableContent.close();
        }, 250);
      } else if (id === "teacherCredentitals") {
        const teacherDetails = title;
        const teacherContent = (
          <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" className='sl_no'>Sr. No.</th>
                  <th scope="col">Teacher Name</th>
                  <th scope="col">Email </th>
                  <th scope="col">Contact Number </th>
                  <th scope="col">Gender </th>
                  <th scope="col">User Id</th>
                  <th scope="col">Password</th>
                  <th scope='col'>Teacher Mapped</th>
                </tr>
              </thead>
              <tbody>
                {
                  teacherDetails?.length > 0 ?
                    teacherDetails?.map((cred, index) => {
                      return (
                        <tr>
                          <th scope="row" className='sl_no'>{index + 1}</th>
                          <td>{cred.teacher.teacherName}</td>
                          <td>{cred.teacher.email}</td>
                          <td>{cred.teacher.contactNumber}</td>
                          <td>{cred.teacher.gender}</td>
                          <td>{cred.userId}</td>
                          <td>{cred.password}</td>
                          <TeacherMappingList teacherMappingDetails={cred.teacher.teacherMappingDetails} />
                        </tr>
                      )
                    })
                    :
                    (<tr>
                      <th colspan={"100%"} style={{ textAlign: 'center' }}>No Credentials Available</th>
                    </tr>)
                }
              </tbody>
            </table>
          </div>
        )

        // const newContent = `
        //   <div>
        //     <div class="heading">
        //       <div class="logo">
        //           <img src=${teacherDetails[0]?.teacher?.instituteMasterDetails?.logoPath} alt="Logo" />
        //       </div>

        //       <div class="text_center">
        //           <h6>${teacherDetails[0]?.teacher?.instituteMasterDetails?.instituteName}</h6>
        //           <h4>${teacherDetails[0]?.teacher?.sectionMasterDetails?.sectionName}</h4>
        //           <h3>${headerTitle}</h3>
        //       </div>
        //       <div class="logo">
        //           <img src=${teacherDetails[0]?.teacher?.sectionMasterDetails?.logoPath} alt="Logo" />
        //       </div>
        //     </div>
        //     ${ReactDOMServer.renderToString(teacherContent)}
        //   </div>
        // `;

        const newContent = `
          <div>
            <div class="heading">
              <div class="logo">
                ${teacherDetails[0]?.teacher?.instituteMasterDetails?.logoPath ?
            `<img src="${teacherDetails[0]?.teacher?.instituteMasterDetails?.logoPath}" alt="Logo" />` : ''
          }
              </div>
              
              <div class="text_center">
                <h6>${teacherDetails[0]?.teacher?.instituteMasterDetails?.instituteName}</h6>
                <h4>${teacherDetails[0]?.teacher?.sectionMasterDetails?.sectionName}</h4>
                <h3>${headerTitle}</h3>
              </div>
              
              <div class="logo">
                ${teacherDetails[0]?.teacher?.sectionMasterDetails?.logoPath ?
            `<img src="${teacherDetails[0]?.teacher?.sectionMasterDetails?.logoPath}" alt="Logo" />` : ''
          }
              </div>
            </div>
            ${ReactDOMServer.renderToString(teacherContent)}
          </div>
        `;

        let printWindowTableContent = window.open(' ', '_blank');

        printWindowTableContent.document.write(`
          <html>
          <head>
          <style>
            @media print {
              body {
                margin: 0;
                padding: 0;
                font-size: 12px;
                color: #000; /* Ensure text is black for high contrast */
              }
        
              .heading {
                display: flex;
                align-items: center;
                justify-content: center;
                background: #004580;
                padding: 10px;
                border-radius: 20px 20px 0 0;
                width: 100%;
                box-sizing: border-box;
                margin-bottom: 0;
                color: #fff; /* Ensure text is white for contrast */
                font-weight: bold; /* Make header text bold */
              }
        
              .heading .text_center h3 {
                // margin: 0;
                // text-align: center;
                font-size: 2.5em;
                // flex-grow: 1;
              }

              .heading .text_center h6, h4 {
                margin: 0;
                font-size: 1.5em;
                // text-align: center;
                // font-size: 2.5em;
                // flex-grow: 1;
              }

              .text_center {
                margin: 0;
                text-align: center;
                flex-grow: 1;
              }
        
              .heading .logo {
                width: 100px;
                flex-shrink: 0;
              }
        
              .heading .logo img {
                max-width: 100%;
                border-radius: 15px;
              }
        
              table {
                border-collapse: collapse;
                width: 100%;
                margin: 0;
              }
        
              table thead tr th {
                background-color: #004580 !important;
                color: #fff !important;
                border-width: 1px;
                padding: 10px;
                vertical-align: middle;
                border-color: #333; /* Darker border color */
                border-style: solid;
                font-weight: bold; /* Make table header text bold */
              }
        
              table tbody tr td,
              table tbody tr th {
                border-width: 1px;
                padding: 10px;
                vertical-align: middle;
                border-color: #333; /* Darker border color */
                color: #000; /* Ensure text color is black for clarity */
                border-style: solid;
              }
        
              table tr tbody td.sl_no,
              table tr thead th.sl_no {
                min-width: 50px;
                width: 50px;
              }
        
              @page {
                size: landscape;
                margin: 10mm; /* Add some margin to avoid cutting off content */
              }
            }
          </style>
          </head>
          <body>
            ${newContent}
          </body>
          </html>
        `);

        setTimeout(() => {
          printWindowTableContent.document.close();
          printWindowTableContent.focus();
          printWindowTableContent.print();
          printWindowTableContent.close();
        }, 250);
      } else if (id === "studentCredentitals") {
        const studentDetails = title;
        const studentContent = (
          <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" className='sl_no'>Sr. No.</th>
                  <th scope="col">Student Name</th>
                  <th scope="col">Email </th>
                  <th scope="col">Contact Number </th>
                  <th scope="col">Gender </th>
                  <th scope="col">Academic Year </th>
                  <th scope="col">Class </th>
                  <th scope="col">Division </th>
                  <th scope="col">User Id</th>
                  <th scope="col">Password</th>
                </tr>
              </thead>
              <tbody>
                {
                  studentDetails?.length > 0 ?
                    studentDetails?.map((cred, index) => {
                      return (
                        <tr>
                          <th scope="row" className='sl_no'>{index + 1}</th>
                          <td>{cred.student.studentName}</td>
                          <td>{cred.student.email}</td>
                          <td>{cred.student.primaryContact}, {cred.student.secondaryContact}</td>
                          <td>{cred.student.gender}</td>
                          <td>{cred.student.academicYearMasterDetails.yearName}</td>
                          <td>{cred.student.instituteGradeMasterDetails.gradeName}</td>
                          <td>{cred.student.instituteDivisionMasterDetails.divisionName}</td>
                          <td>{cred.userId}</td>
                          <td>{cred.password}</td>
                        </tr>
                      )
                    })
                    :
                    (<tr>
                      <th colspan={"100%"} style={{ textAlign: 'center' }}>No Credentials Available</th>

                    </tr>)
                }
              </tbody>
            </table>
          </div>
        )

        const newContent = `
          <div>
            <div class="heading">
              <div class="logo">
                ${studentDetails[0]?.student?.instituteMasterDetails?.logoPath ?
            `<img src="${studentDetails[0]?.student?.instituteMasterDetails?.logoPath}" alt="Logo" />` : ''
          }
              </div>
              
              <div class="text_center">
                <h6>${studentDetails[0]?.student?.instituteMasterDetails?.instituteName}</h6>
                <h4>${studentDetails[0]?.student?.sectionMasterDetails?.sectionName}</h4>
                <h3>${headerTitle}</h3>
              </div>
              
              <div class="logo">
                ${studentDetails[0]?.student?.sectionMasterDetails?.logoPath ?
            `<img src="${studentDetails[0]?.student?.sectionMasterDetails?.logoPath}" alt="Logo" />` : ''
          }
              </div>
            </div>
            ${ReactDOMServer.renderToString(studentContent)}
          </div>
        `;

        let printWindowTableContent = window.open(' ', '_blank');

        printWindowTableContent.document.write(`
          <html>
          <head>
          <style>
            @media print {
              body {
                margin: 0;
                padding: 0;
                font-size: 12px;
                color: #000; /* Ensure text is black for high contrast */
              }
        
              .heading {
                display: flex;
                align-items: center;
                justify-content: center;
                background: #004580;
                padding: 10px;
                border-radius: 20px 20px 0 0;
                width: 100%;
                box-sizing: border-box;
                margin-bottom: 0;
                color: #fff; /* Ensure text is white for contrast */
                font-weight: bold; /* Make header text bold */
              }
        
              .heading .text_center h3 {
                // margin: 0;
                // text-align: center;
                font-size: 2.5em;
                // flex-grow: 1;
              }

              .heading .text_center h6, h4 {
                margin: 0;
                font-size: 1.5em;
                // text-align: center;
                // font-size: 2.5em;
                // flex-grow: 1;
              }

              .text_center {
                margin: 0;
                text-align: center;
                flex-grow: 1;
              }
        
              .heading .logo {
                width: 100px;
                flex-shrink: 0;
              }
        
              .heading .logo img {
                max-width: 100%;
                border-radius: 15px;
              }
        
              table {
                border-collapse: collapse;
                width: 100%;
                margin: 0;
              }
        
              table thead tr th {
                background-color: #004580 !important;
                color: #fff !important;
                border-width: 1px;
                padding: 10px;
                vertical-align: middle;
                border-color: #333; /* Darker border color */
                border-style: solid;
                font-weight: bold; /* Make table header text bold */
              }
        
              table tbody tr td,
              table tbody tr th {
                border-width: 1px;
                padding: 10px;
                vertical-align: middle;
                border-color: #333; /* Darker border color */
                color: #000; /* Ensure text color is black for clarity */
                border-style: solid;
              }
        
              table tr tbody td.sl_no,
              table tr thead th.sl_no {
                min-width: 50px;
                width: 50px;
              }
        
              @page {
                size: landscape;
                margin: 10mm; /* Add some margin to avoid cutting off content */
              }
            }
          </style>
          </head>
          <body>
            ${newContent}
          </body>
          </html>
        `);

        setTimeout(() => {
          printWindowTableContent.document.close();
          printWindowTableContent.focus();
          printWindowTableContent.print();
          printWindowTableContent.close();
        }, 250);
      } else if (id === "dssPaymentReport") {
        const InstituteMasterDetails = title?.InstituteMasterDetails;
        const dssDetails = title?.paymentList;
        const studentContent = (
          <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" className='sl_no'>Sr. No.</th>
                  <th scope="col">Section Name</th>
                  <th scope="col">Teacher Name</th>
                  <th scope="col">Teacher Email</th>
                  <th scope="col">Student Name</th>
                  <th scope="col">Student Email</th>
                  <th scope="col">Academic Year</th>
                  <th scope="col">Class</th>
                  <th scope="col">Division</th>
                  <th scope="col">Dss Title</th>
                  <th scope="col">Order Id</th>
                  <th scope="col">Amount</th>
                </tr>
              </thead>
              <tbody>
                {
                  dssDetails?.length > 0 ?
                    dssDetails?.map((dss, index) => {
                      return (
                        <tr>
                          <th scope="row" className='sl_no'>{index + 1}</th>
                          <td>{dss?.student?.section}</td>
                          <td>{dss?.teacher?.name}</td>
                          <td>{dss?.teacher?.email}</td>
                          <td>{dss?.student?.name}</td>
                          <td>{dss?.student?.email}</td>
                          <td>{dss?.student?.academicYear}</td>
                          <td>{dss?.student?.grade}</td>
                          <td>{dss?.student?.division}</td>
                          <td>{dss?.dssTitle}</td>
                          <td>{dss?.orderId}</td>
                          <td>{dss?.amount}</td>
                        </tr>
                      )
                    })
                    :
                    (<tr>
                      <th colspan={"100%"} style={{ textAlign: 'center' }}>No Credentials Available</th>
                    </tr>)
                }
              </tbody>
            </table>
          </div>
        )

        const newContent = `
          <div>
            <div class="heading">
              <div class="logo">
                ${VidyaUpasna ?
            `<img src="${VidyaUpasna}" alt="Logo" />` : ''
          }
              </div>
              
              <div class="text_center">
                <h6>Next Gen Education</h6>
                <h4>${InstituteMasterDetails?.instituteName}</h4>
                <h3>${headerTitle}</h3>
              </div>
              
              <div class="logo">
                ${InstituteMasterDetails?.logoPath ?
            `<img src="${InstituteMasterDetails?.logoPath}" alt="Logo" />` : ''
          }
              </div>
            </div>
            ${ReactDOMServer.renderToString(studentContent)}
          </div>
        `;

        let printWindowTableContent = window.open(' ', '_blank');

        printWindowTableContent.document.write(`
          <html>
          <head>
          <style>
            @media print {
              body {
                margin: 0;
                padding: 0;
                font-size: 12px;
                color: #000; /* Ensure text is black for high contrast */
              }
        
              .heading {
                display: flex;
                align-items: center;
                justify-content: center;
                background: #004580;
                padding: 10px;
                border-radius: 20px 20px 0 0;
                width: 100%;
                box-sizing: border-box;
                margin-bottom: 0;
                color: #fff; /* Ensure text is white for contrast */
                font-weight: bold; /* Make header text bold */
              }
        
              .heading .text_center h3 {
                // margin: 0;
                // text-align: center;
                font-size: 2.5em;
                // flex-grow: 1;
              }

              .heading .text_center h6, h4 {
                margin: 0;
                font-size: 1.5em;
                // text-align: center;
                // font-size: 2.5em;
                // flex-grow: 1;
              }

              .text_center {
                margin: 0;
                text-align: center;
                flex-grow: 1;
              }
        
              .heading .logo {
                width: 100px;
                flex-shrink: 0;
              }
        
              .heading .logo img {
                max-width: 100%;
                border-radius: 15px;
              }
        
              table {
                table-layout: auto;
                word-wrap: break-word;
                border-collapse: collapse;
                width: 100%;
                max-width: 100%;
                margin: 0;
              }
        
              table thead tr th {
                background-color: #004580 !important;
                color: #fff !important;
                border-width: 1px;
                padding: 10px;
                vertical-align: middle;
                border-color: #333; /* Darker border color */
                border-style: solid;
                font-weight: bold; /* Make table header text bold */
              }
        
              table tbody tr td,
              table tbody tr th {
                border-width: 1px;
                padding: 10px;
                vertical-align: middle;
                border-color: #333; /* Darker border color */
                color: #000; /* Ensure text color is black for clarity */
                border-style: solid;
                word-break: break-word;
                white-space: normal;
              }
        
              table tr tbody td.sl_no,
              table tr thead th.sl_no {
                min-width: 50px;
                width: 50px;
              }
        
              @page {
                size: landscape;
                margin: 10mm; /* Add some margin to avoid cutting off content */
              }
            }
          </style>
          </head>
          <body>
            ${newContent}
          </body>
          </html>
        `);

        setTimeout(() => {
          printWindowTableContent.document.close();
          printWindowTableContent.focus();
          printWindowTableContent.print();
          printWindowTableContent.close();
        }, 250);
      } else if (id === "teacherPerformance") {
        const today = moment().format('DD-MM-YYYY');
        const teacherList = title;
        const teacherContent = (
          <div class="report_block">
            <div class="heading">
              <div class="logo">
                <img src={teacherList?.instituteMasterDetails?.logoPath} alt="" />
              </div>
              <div class="text_center">
                <h6>{teacherList?.instituteMasterDetails?.instituteName}</h6>
                <h4>{teacherList?.sectionMasterDetails?.sectionName}</h4>
              </div>
              <div class="logo">
                <img src={VidyaUpasna} alt="" />
              </div>
            </div>
            <div class="report_code text_center mb-3">
              <img src={separator_line} alt="" className="line" />
              <span className="txt">Teacher Performance {today}</span>
            </div>

            <div class="report_head">
              <span>Board: {teacherList?.sectionMasterDetails?.boardMasterDetails?.boardName}</span>
              <span>Medium: {teacherList?.sectionMasterDetails?.streamOrMediumMasterDetails?.streamName}</span>
            </div>

            <div class="analysis_report schedule_table">
              {/* <span class="table_caption">Name of Report : Class Exam</span> */}
              <table>
                <thead>
                  <tr>
                    <th scope="col" className='sl_no'>Sr. No.</th>
                    <th scope="col">Teacher Name</th>
                    <th scope="col">Class</th>
                    <th scope="col">Division</th>
                    <th scope="col">Subject</th>
                    <th scope="col">Daily Teaching Count</th>
                    <th scope="col">Assignment Count</th>
                    <th scope="col">Exam Count</th>
                    <th scope="col">Completion Percentage</th>
                    <th scope="col">Rating</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    teacherList.data.length > 0 ?
                      teacherList.data.map((teacher, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{teacher?.teacherName}</td>
                            <td>{teacher?.teacherMappingDetails?.map(grade => grade.instituteGradeMasterDetails.gradeName).join(', ')}</td>
                            <td>{teacher?.teacherMappingDetails?.map(grade => grade.instituteDivisionMasterDetails.divisionName).join(', ')}</td>
                            <td>{teacher?.teacherMappingDetails?.map(grade => grade.instituteSubjectMasterDetails.subjectName).join(', ')}</td>
                            <td>{teacher?.dailyTeachingCount}</td>
                            <td>{teacher?.dailyAssignmentCount}</td>
                            <td>{teacher?.totalExamsCount}</td>
                            <td>{teacher?.completionPercentage}</td>
                            <td>{teacher?.ratingAverage}</td>
                          </tr>
                        )
                      })
                      :
                      (<tr>
                        <th colspan={"100%"} style={{ textAlign: 'center' }}>No Exam Available</th>
                      </tr>)
                  }
                </tbody>
              </table>
            </div>

            <div class="report_footer">
              <div>
                <span>{getCurrentTime()}</span>
                <span>Time stamp of export</span>
              </div>
              <div>
                {/* <span>{teachingPlan[0]?.teacherMasterDetails?.teacherName}</span> */}
                <span>Supervisor Signature</span>
              </div>
              <div>
                {/* <span>{teachingPlan[0]?.teacherMasterDetails?.teacherName}</span> */}
                <span>Principle Signature</span>
              </div>
            </div>
          </div>
        )

        // const newContent = `
        //   <div>
        //     <h3 style="text-align: center;">Teacher Deatils Details</h3>
        //     ${ReactDOMServer.renderToString(teacherContent)}
        //   </div>
        // `;
        let printWindowReportContent = window.open(' ', '_blank');
        // Write the HTML to the new window, including the content to print
        printWindowReportContent.document.write(`
          <html>
          <head>
          <style>
          @media print{
            .report_code {
              position: relative;
            }
            .report_code .line {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 0;
              width: 100%;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            table thead tr th,
            table tbody tr td,
            table tfoot tr th {
              padding: 8px;
              border: 1px solid #000;
              text-align: center;
              vertical-align: middle;
            }

            .exam_report table tbody tr td {
              color: #a80000;
            }

            .table_caption {
              display: block;
              text-align: center;
              font-weight: 600;
              margin: 16px 0;
            }

            .analysis_report table thead tr th,
            .analysis_report table tfoot tr th {
              color: #a80000;
            }

            .text_right {
              text-align: right;
            }

            .text_center {
              text-align: center;
            }

            .report_block .heading {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            .report_block .heading .logo {
              width: 100px;
            }

            .report_block .heading .logo img {
              max-width: 100%;
            }

            .report_block .report_code span.txt {
              display: inline-block;
              padding: 8px 20px;
              border-radius: 8px;
              border: 1px solid #000;
              background: #fff;
              position: relative;
              z-index: 1;
            }

            .report_block .report_head {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin: 32px 0;
              text-align: center;
            }

            .report_block .report_head span {
              display: block;
            }

            .report_block .report_footer {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              margin-top: 24px;
            }

            .report_block .report_footer div {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 16px;
            }

            .report_block .report_footer span {
              display: block;
              color: #a80000;
              font-weight: 500;
              text-align: center !important;
            }

            .candidate_details table tbody tr td {
              text-align: left;
              padding: 24px;
            }
          }
        
          </style>
          </head>
          <body>
          ${ReactDOMServer.renderToString(teacherContent)}
          </body>
          </html>
        `);

        // Delay to ensure content is written before printing
        setTimeout(() => {
          printWindowReportContent.document.close(); // Close the document to complete the writing process
          printWindowReportContent.focus(); // Focus on the new window
          printWindowReportContent.print(); // Invoke the native print function
          printWindowReportContent.close(); // Close the print window after printing
        }, 250); // Adjust delay as needed
      } else if (id === 'adminQuestionDetails') {
        content?.querySelector('.pagination')?.remove();
        // const newContent = `
        //   <div id="printContainer"> <!-- Container to hold heading and content -->
        //     <div class="heading heading-layout">
        //       <div class="logo">
        //         <img src=${VidyaUpasna} alt="" />
        //       </div>
        //       <h3 class="title text_center">${title}</h3>
        //     </div>
        //     <div class="content">
        //       ${content.innerHTML}
        //     </div>
        //   </div>
        // `;

        const newContent = `
          <div>
            <div class="heading">
              <div class="logo">
                  <img src=${"https://api.examninja.co.in/images/1705820792167-939.jpeg"} alt="" />
              </div>
              <div class="text_center">
                <h6>Next Gen Education</h6>
                <h4>${title}</h4>
              </div>
              <div class="logo">
                  <img src=${VidyaUpasna} alt="" />
              </div>
            </div>
            ${content.innerHTML}
          </div>
        `;

        // <h3 class="text_center">${title}</h3>

        let printWindowTableContent = window.open(' ', '_blank');

        printWindowTableContent.document.write(`
          <html>
          <head>
          <style>
            @media print {
              /* CSS reset */
              * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }
              
              body {
                width: 100%;
                padding: 0;
                margin: 0;
              }

              #printContainer {
                width: 100%;
                padding: 0 10px; /* Adjust as needed */
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }
              
              table {
                border-collapse: collapse;
                width: 100%; /* Ensure table takes full width */
              }

              table thead tr th {
                background-color: #fff !important;
                color: #000 !important;
                border-width: 1px;             
                padding: 10px;
                vertical-align: middle;
                border-color: #000;
                border-style: solid;
              } 

              table tbody tr td,
              table tbody tr th {              
                border-width: 1px;             
                padding: 10px;
                vertical-align: middle;
                border-color: #000;
                color: #000;
                border-style: solid;
              }
              
              table tr tbody td.sl_no, table tr thead th.sl_no {
                min-width: 50px;
                width: 50px;
              }

              .heading .text_center h3 {
                // margin: 0;
                // text-align: center;
                font-size: 2.5em;
                // flex-grow: 1;
              }

              .heading .text_center h6, h4 {
                margin: 0;
                font-size: 1.5em;
                // text-align: center;
                // font-size: 2.5em;
                // flex-grow: 1;
              }

              .text_center {
                margin: 0;
                text-align: center;
                flex-grow: 1;
              }
              
              .row.exam-result-header {
                display: flex;
                gap: 10px;
                margin-bottom: 10px;
                align-items: center;
                justify-content: space-between;
              } 
              
              #tableContent button {
                display: none;
              }
              
              #tableContent h3 {
                text-align: center;
                margin-bottom: 20px;
              }
              
              #preview-1000 {
                display: flex;
                justify-content: center;
              }
              
              .heading {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%; /* Set heading width to 100% */
                background: #004580;
                padding: 20px;
                border-radius: 20px 20px 0 0;
                border: 1px solid #000;
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }

              .heading h3 {
                color: #fff;
                margin: 0;
                flex-grow: 1;
                text-align: center;
              }

              .heading .logo {
                width: 100px;
                flex-shrink: 0;
              }

              .heading .logo img {
                max-width: 100%;
                border-radius: 15px;
              }

              .heading-layout {
                display: flex;
                align-items: center;
                width: 100%; /* Ensure heading-layout takes full width */
                background: #004580;
                padding: 20px;
                border-radius: 20px 20px 0 0;
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }

              .content {
                width: 100%;
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }
            }
          </style>
          </head>
          <body>
          ${newContent}
          </body>
          </html>
        `);

        setTimeout(() => {
          printWindowTableContent.document.close();
          printWindowTableContent.focus();
          printWindowTableContent.print();
          printWindowTableContent.close();
        }, 250);
      } else if (id === 'appSubscribedStudent') {
        const data = title;
        const content = (
          <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Sr. No.</th>
                  <th scope="col">Current Subscription</th>
                  <th scope="col">Section Name</th>
                  <th scope="col">User Name</th>
                  <th scope="col">Name</th>
                  <th scope="col">Academic Year</th>
                  <th scope="col">Class</th>
                  <th scope="col">Division</th>
                  <th scope="col">Phone No</th>
                  <th scope="col">Email</th>
                  <th scope="col">Coupon Code</th>
                </tr>
              </thead>
              <tbody>
                {
                  data?.length > 0 ?
                    data?.map((std, index) => {
                      return (
                        <>
                          <tr>
                            <th scope="row" className='sl_no'>{index + 1}</th>
                            <td>{std?.subscriptionDetails?.subscriptionName}</td>
                            <td>{std?.studentDetails?.sectionMasterDetails?.sectionName}</td>
                            <td>{std?.studentDetails?.studentId}</td>
                            <td>{std?.studentDetails?.studentName}</td>
                            <td>{std?.studentDetails?.academicYearMasterDetails?.yearName}</td>
                            <td>{std?.studentDetails?.instituteGradeMasterDetails?.gradeName}</td>
                            <td>{std?.studentDetails?.instituteDivisionMasterDetails?.divisionName}</td>
                            <td>{std?.studentDetails?.primaryContact}</td>
                            <td>{std?.studentDetails?.email}</td>
                            <td>{std?.paymentOrderDetails[0]?.couponCodeDetails?.code}</td>
                          </tr>
                        </>
                      )
                    })
                    :
                    (<tr>
                      <th colspan={"100%"} style={{ textAlign: 'center' }}>No Question Available</th>
                    </tr>)
                }
              </tbody>
            </table>
          </div>
        )

        const newContent = `
          <div>
            <div class="heading">
              <div class="logo">
                  <img src=${"https://api.examninja.co.in/images/1705820792167-939.jpeg"} alt="" />
              </div>
              <div class="text_center">
                <h6>Next Gen Education</h6>
                <h4>${headerTitle}</h4>
              </div>
              <div class="logo">
                  <img src=${VidyaUpasna} alt="" />
              </div>
            </div>
            ${ReactDOMServer.renderToString(content)}
          </div>
        `;

        let printWindowTableContent = window.open(' ', '_blank');

        printWindowTableContent.document.write(`
          <html>
          <head>
          <style>
            @media print {
              * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }
              
              body {
                width: 100%;
                padding: 0;
                margin: 0;
              }

              #printContainer {
                width: 100%;
                padding: 0 10px; /* Adjust as needed */
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }
              
              table {
                border-collapse: collapse;
                // width: 100%; /* Ensure table takes full width */
                width: 100% !important; /* Ensures table takes full width */
                table-layout: auto !important; /* Prevents column overflow */
                word-break: break-word; /* Allows cell content to wrap */
              }

              table thead tr th {
                background-color: #fff !important;
                color: #000 !important;
                border-width: 1px;             
                padding: 10px;
                vertical-align: middle;
                border-color: #000;
                border-style: solid;
              } 

              table tbody tr td,
              table tbody tr th {              
                border-width: 1px;             
                padding: 10px;
                vertical-align: middle;
                border-color: #000;
                color: #000;
                border-style: solid;
              }
              
              table tr tbody td.sl_no, table tr thead th.sl_no {
                min-width: 50px;
                width: 50px;
              }

              .heading .text_center h3 {
                font-size: 2.5em;
              }

              .heading .text_center h6, h4 {
                margin: 0;
                font-size: 1.5em;
              }

              .text_center {
                margin: 0;
                text-align: center;
                flex-grow: 1;
              }
              
              .row.exam-result-header {
                display: flex;
                gap: 10px;
                margin-bottom: 10px;
                align-items: center;
                justify-content: space-between;
              } 
              
              #tableContent button {
                display: none;
              }
              
              #tableContent h3 {
                text-align: center;
                margin-bottom: 20px;
              }
              
              #preview-1000 {
                display: block;
                justify-content: center;
              }
              
              .heading {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%; /* Set heading width to 100% */
                background: #004580;
                padding: 20px;
                border-radius: 20px 20px 0 0;
                border: 1px solid #000;
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }

              .heading h3 {
                color: #fff;
                margin: 0;
                flex-grow: 1;
                text-align: center;
              }

              .heading .logo {
                width: 100px;
                flex-shrink: 0;
              }

              .heading .logo img {
                max-width: 100%;
                border-radius: 15px;
              }

              .heading-layout {
                display: flex;
                align-items: center;
                width: 100%; /* Ensure heading-layout takes full width */
                background: #004580;
                padding: 20px;
                border-radius: 20px 20px 0 0;
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }

              .content {
                width: 100%;
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }

            }
          </style>
          </head>
          <body>
          ${newContent}
          </body>
          </html>
        `);


        setTimeout(() => {
          printWindowTableContent.document.close();
          printWindowTableContent.focus();
          printWindowTableContent.print();
          printWindowTableContent.close();
        }, 250);
      } else if (id === 'adminSubjectQuestionDetails') {
        const data = title;
        const totalUniqueClass = new Set(data.map(exam => exam?.gradeMasterDetails?.id)).size;
        const totalUniqueExamName = new Set(data.map(exam => exam?.competitiveExamNameMasterDetails?.id)).size;
        const totalUniqueExamBook = new Set(data.map(exam => exam?.competitiveExamBookMasterDetails?.id)).size;
        const totalUniqueSubject = new Set(data.map(exam => exam?.competitiveExamNameMasterSubjectDetails?.id)).size;
        const subjectTotalQuestion = data?.reduce((sum, exam) => sum + (Number(exam?.questionCount) || 0), 0);
        // const content = (
        //   <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
        //     <table class="table">
        //       <thead>
        //         <tr>
        //           <th scope="col">Sr. No.</th>
        //           <th scope="col">Exam Name</th>
        //           <th scope="col">Class</th>
        //           <th scope="col">Book Name</th>
        //           <th scope="col">Subject</th>
        //           <th scope="col">Total Question</th>
        //           <th scope="col">Last Updated</th>
        //         </tr>
        //       </thead>
        //       <tbody>
        //         {
        //           data?.length > 0 ?
        //             data?.map((exam, index) => {
        //               const isLast = index === data.length - 1;
        //               return (
        //                 <>
        //                   <tr>
        //                     <th scope="row" className='sl_no'>{index + 1}</th>
        //                     <td>{exam?.gradeMasterDetails?.gradeName}</td>
        //                     <td>{exam?.competitiveExamNameMasterDetails?.examName}</td>
        //                     <td>{exam?.competitiveExamBookMasterDetails?.bookName}</td>
        //                     <td>{exam?.competitiveExamNameMasterSubjectDetails?.subjectName}</td>
        //                     <td>{exam?.questionCount}</td>
        //                     <td>{exam?.lastQuestionUpdatedDate}</td>
        //                   </tr>
        //                   {isLast && (
        //                     <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
        //                       <td colSpan={"2"}>Total Class: {totalUniqueClass}</td>
        //                       <td>Total Exam Name: {totalUniqueExamName}</td>
        //                       <td>Total Exam Book: {totalUniqueExamBook}</td>
        //                       <td>Total Subject: {totalUniqueSubject}</td>
        //                       <td>Total Questions: {subjectTotalQuestion}</td>
        //                       <td></td>
        //                     </tr>
        //                   )}
        //                 </>
        //               )
        //             })
        //             :
        //             (<tr>
        //               <th colspan={"100%"} style={{ textAlign: 'center' }}>No Question Available</th>
        //             </tr>)
        //         }
        //       </tbody>
        //     </table>
        //   </div>
        // )

        // const newContent = `
        //   <div>
        //     <div class="heading">
        //       <div class="logo">
        //           <img src=${"https://api.examninja.co.in/images/1705820792167-939.jpeg"} alt="" />
        //       </div>
        //       <div class="text_center">
        //         <h6>Next Gen Education</h6>
        //         <h4>${headerTitle}</h4>
        //       </div>
        //       <div class="logo">
        //           <img src=${VidyaUpasna} alt="" />
        //       </div>
        //     </div>
        //     ${ReactDOMServer.renderToString(content)}
        //   </div>
        // `;

        const content = (
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Exam Name</th>
                <th scope="col">Class</th>
                <th scope="col">Book Name</th>
                <th scope="col">Subject</th>
                <th scope="col">Total Question</th>
                <th scope="col">Last Updated</th>
              </tr>
            </thead>
            <tbody>
              {data.map((exam, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{exam?.gradeMasterDetails?.gradeName}</td>
                  <td>{exam?.competitiveExamNameMasterDetails?.examName}</td>
                  <td>{exam?.competitiveExamBookMasterDetails?.bookName}</td>
                  <td>{exam?.competitiveExamNameMasterSubjectDetails?.subjectName}</td>
                  <td>{exam?.questionCount}</td>
                  <td>{exam?.lastQuestionUpdatedDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        );

        const footerHTML = `
          <div class="report_footer">
            <div>Total Class: ${totalUniqueClass}</div>
            <div>Total Exam Name: ${totalUniqueExamName}</div>
            <div>Total Exam Book: ${totalUniqueExamBook}</div>
            <div>Total Subject: ${totalUniqueSubject}</div>
            <div>Total Questions: ${subjectTotalQuestion}</div>
          </div>
        `;
        const newContent = `
          <div>
            <div class="heading">
              <div class="logo">
                <img src="https://api.examninja.co.in/images/1705820792167-939.jpeg" alt="" />
              </div>
              <div class="text_center">
                <h6>Next Gen Education</h6>
                <h4>${headerTitle}</h4>
              </div>
              <div class="logo">
                <img src=${VidyaUpasna} alt="" />
              </div>
            </div>
            <div class="report_wrap">
              ${ReactDOMServer.renderToString(content)}
              ${footerHTML} <!-- ✅ Footer added as HTML after table -->
            </div>
          </div>
        `;


        let printWindowTableContent = window.open(' ', '_blank');

        printWindowTableContent.document.write(`
          <html>
          <head>
          <style>
            @media print {
              /* CSS reset */
              * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }
              
              body {
                width: 100%;
                padding: 0;
                margin: 0;
              }

              #printContainer {
                width: 100%;
                padding: 0 10px; /* Adjust as needed */
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }
              
              table {
                border-collapse: collapse;
                width: 100%; /* Ensure table takes full width */
              }

              table thead tr th {
                background-color: #fff !important;
                color: #000 !important;
                border-width: 1px;             
                padding: 10px;
                vertical-align: middle;
                border-color: #000;
                border-style: solid;
              } 

              table tbody tr td,
              table tbody tr th {              
                border-width: 1px;             
                padding: 10px;
                vertical-align: middle;
                border-color: #000;
                color: #000;
                border-style: solid;
              }
              
              table tr tbody td.sl_no, table tr thead th.sl_no {
                min-width: 50px;
                width: 50px;
              }

              .heading .text_center h3 {
                // margin: 0;
                // text-align: center;
                font-size: 2.5em;
                // flex-grow: 1;
              }

              .heading .text_center h6, h4 {
                margin: 0;
                font-size: 1.5em;
                // text-align: center;
                // font-size: 2.5em;
                // flex-grow: 1;
              }

              .text_center {
                margin: 0;
                text-align: center;
                flex-grow: 1;
              }
              
              .row.exam-result-header {
                display: flex;
                gap: 10px;
                margin-bottom: 10px;
                align-items: center;
                justify-content: space-between;
              } 
              
              #tableContent button {
                display: none;
              }
              
              #tableContent h3 {
                text-align: center;
                margin-bottom: 20px;
              }
              
              #preview-1000 {
                display: flex;
                justify-content: center;
              }
              
              .heading {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%; /* Set heading width to 100% */
                background: #004580;
                padding: 20px;
                border-radius: 20px 20px 0 0;
                border: 1px solid #000;
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }

              .heading h3 {
                color: #fff;
                margin: 0;
                flex-grow: 1;
                text-align: center;
              }

              .heading .logo {
                width: 100px;
                flex-shrink: 0;
              }

              .heading .logo img {
                max-width: 100%;
                border-radius: 15px;
              }

              .heading-layout {
                display: flex;
                align-items: center;
                width: 100%; /* Ensure heading-layout takes full width */
                background: #004580;
                padding: 20px;
                border-radius: 20px 20px 0 0;
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }

              .content {
                width: 100%;
                box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
              }

              .report_footer {
                margin-top: 20px;
                padding: 16px;
                border: 1px solid #000;
                border-radius: 8px;
                background-color: #f8f9fa;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                color: #000;
                font-weight: bold;
                gap: 10px;
                width: 100%;
                box-sizing: border-box;
              }

              .report_footer > div {
                flex: 1 1 200px;
                text-align: center;
              }

            }
          </style>
          </head>
          <body>
          ${newContent}
          </body>
          </html>
        `);

        setTimeout(() => {
          printWindowTableContent.document.close();
          printWindowTableContent.focus();
          printWindowTableContent.print();
          printWindowTableContent.close();
        }, 250);
      } else if (id === 'studentAttendance') {
        let printWindowReportContent = window.open(' ', '_blank');
        // Write the HTML to the new window, including the content to print
        printWindowReportContent.document.write(`
          <html>
          <head>
          <style>
          @media print{
            @page {
              size: landscape;
            }

            .report_code {
              position: relative;
            }

            .report_code .line {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 0;
              width: 100%;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            table thead tr th,
            table tbody tr td,
            table tfoot tr th {
              padding: 8px;
              border: 1px solid #000;
              text-align: center;
              vertical-align: middle;
            }

            .exam_report table tbody tr td {
              color: #a80000;
            }

            .table_caption {
              display: block;
              text-align: center;
              font-weight: 600;
              margin: 16px 0;
            }

            .analysis_report table thead tr th,
            .analysis_report table tfoot tr th {
              color: #a80000;
            }

            .text_right {
              text-align: right;
            }

            .text_center {
              text-align: center;
            }

            .report_block .heading {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            .report_block .heading .logo {
              width: 100px;
            }

            .report_block .heading .logo img {
              max-width: 100%;
            }

            .report_block .report_code span.txt {
              display: inline-block;
              padding: 8px 20px;
              border-radius: 8px;
              border: 1px solid #000;
              background: #f1f1f1;
              position: relative;
              z-index: 1;
            }

            .report_block .report_head {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin: 32px 0;
              text-align: center;
            }

            .report_block .report_head span {
              display: block;
            }

            .report_block .report_footer {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              margin-top: 24px;
            }

            .report_block .report_footer div {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 16px;
            }

            .report_block .report_footer span {
              display: block;
              color: #a80000;
              font-weight: 500;
              text-align: center !important;
            }

            .candidate_details table tbody tr td {
              text-align: left;
              padding: 24px;
            }
          }
          </style>
          </head>
          <body>
          ${content.outerHTML}
          </body>
          </html>
        `);

        // Delay to ensure content is written before printing
        setTimeout(() => {
          printWindowReportContent.document.close(); // Close the document to complete the writing process
          printWindowReportContent.focus(); // Focus on the new window
          printWindowReportContent.print(); // Invoke the native print function
          printWindowReportContent.close(); // Close the print window after printing
        }, 250); // Adjust delay as needed
      } else if (id === 'examPaper') {
        let printWindowReportContent = window.open(' ', '_blank');
        // Write the HTML to the new window, including the content to print
        printWindowReportContent.document.write(`
          <html>
          <head>
          <style>
          @media print{

            .generate_pdf_question_paper_report_block {
              padding: 24px;
              box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
              border-radius: 12px;
              font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              max-width: 900px;
              margin: 20px auto;
              background-color: #fff;
              overflow-x: auto;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading {
              display: flex;
              align-items: center;
              justify-content: space-between;
              // border-bottom: 2px solid #f0f0f0;
              padding-bottom: 16px;
              margin-bottom: 16px;
              // padding-bottom: 4px;
              // margin-bottom: 4px;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading .generate_pdf_question_paper_logo {
              width: 100px;
              flex-shrink: 0;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading .generate_pdf_question_paper_logo img {
              max-width: 100%;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading .text_center {
              text-align: center;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading .text_center h6 {
              font-size: 16px;
              font-weight: 500;
              color: #666;
              margin: 0;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading .text_center h4 {
              font-size: 20px;
              font-weight: bold;
              color: #333;
              margin: 4px 0 0;
            }

            .generate_pdf_question_paper_report_code {
              margin: 20px 0;
              text-align: center;
            }

            .generate_pdf_question_paper_report_code .line {
              display: block;
              margin: 0 auto;
              width: 100%;
              height: 2px;
              background-color: #ddd;
            }

            .generate_pdf_question_paper_details {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 20px;
              padding: 16px;
              background: #f9f9f9;
              border: 1px solid #e0e0e0;
              border-radius: 8px;
              font-size: 16px;
              color: #444;
            }

            .generate_pdf_question_paper_details span {
              font-weight: bold;
              color: #333;
            }

            .generate_pdf_question_paper_instructions {
              margin-top: 20px;
              padding: 16px;
              border: 1px solid #e0e0e0;
              background-color: #f9f9f9;
              border-radius: 8px;
            }

            .generate_pdf_question_paper_instructions h3 {
              font-size: 18px;
              font-weight: bold;
              color: #333;
              margin-bottom: 10px;
            }

            .generate_pdf_question_paper_instructions ul {
              padding-left: 20px;
              margin: 0;
            }

            .generate_pdf_question_paper_instructions ul li {
              font-size: 14px;
              color: #555;
              margin-bottom: 5px;
            }

            .generate_pdf_question_paper_generated_pdf_total_question {
              margin-top: 20px;
                max-width:calc(100% - 25px);
                padding-left:0;
                margin-left:auto;
                margin-right:auto;
            }

            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question {
              margin-bottom: 20px;
              font-family: Arial, sans-serif;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question p {
              font-size: 16px;
              font-weight: normal;
              color: #333;
              margin-bottom: 10px;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ol {
              padding-left: 0;
              margin: 0;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ul {
              list-style-type: none;
              margin: 0;
              padding-left: 20px;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ul li {
              font-size: 16px;
              color: #444;
              margin-bottom: 8px;
              padding-left: 35px; /* Adjust space to align with the bubble */
              position: relative;
              line-height: 1.5;
            }

            /* Circle for the option letter */
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ul li:before {
              content: attr(data-option);
              position: absolute;
              left: 0;
              top: 0;
              width: 24px; /* Circle width */
              height: 24px; /* Circle height */
              background-color: transparent; /* Circle background color */
              border: 2px solid #333; /* Circle border */
              border-radius: 50%; /* Makes it a perfect circle */
              display: flex;
              justify-content: center;
              align-items: center;
              font-weight: bold;
              font-size: 14px;
              color: #333; /* Text inside the bubble */
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ul li span {
              font-weight: normal;
              font-size: 16px;
              margin-left: 10px;
              color: #444;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_generated_pdf_total_question ol li {
              font-size: 16px;
              color: #444;
              margin-bottom: 8px;
              line-height: 1.6;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ol li:before {
              content: counter(item) '.';
              counter-increment: item;
              position: absolute;
              left: 0;
              top: 0;
              font-weight: normal;
              color: #333;
              font-size: 18px;
              padding-left: 10px;
            }

            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ol {
              counter-reset: item;
            }

            .custom_class{
              height:auto;
              padding-bottom:0;
            }



          }
          </style>
          </head>
          <body>
          ${content.outerHTML}
          </body>
          </html>
        `);

        // Delay to ensure content is written before printing
        setTimeout(() => {
          printWindowReportContent.document.close();
          printWindowReportContent.focus();
          printWindowReportContent.print();
          printWindowReportContent.close();
        }, 250);
      } else if (id === 'AIBasedTeachingReport') {
        let printWindowReportContent = window.open(' ', '_blank');
        // Write the HTML to the new window, including the content to print
        printWindowReportContent.document.write(`
          <html>
          <head>
          <style>
          @media print{

            .generate_pdf_question_paper_report_block {
              padding: 24px 0;
              // box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
              border-radius: 12px;
              font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              // max-width: 900px;
              // margin: 20px auto;
                max-width: 100%;
                // width: 100vw;
                margin: 0;
              background-color: #fff;
              overflow-x: auto;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading {
              display: flex;
              align-items: center;
              justify-content: space-between;
              // border-bottom: 2px solid #f0f0f0;
              padding-bottom: 16px;
              margin-bottom: 16px;
              // padding-bottom: 4px;
              // margin-bottom: 4px;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading .generate_pdf_question_paper_logo {
              width: 100px;
              flex-shrink: 0;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading .generate_pdf_question_paper_logo img {
              max-width: 100%;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading .text_center {
              text-align: center;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading .text_center h6 {
              font-size: 16px;
              font-weight: 500;
              color: #666;
              margin: 0;
            }

            .generate_pdf_question_paper_report_block .generate_pdf_question_paper_heading .text_center h4 {
              font-size: 20px;
              font-weight: bold;
              color: #333;
              margin: 4px 0 0;
            }

            .generate_pdf_question_paper_report_code {
              margin: 20px 0;
              text-align: center;
            }

            .generate_pdf_question_paper_report_code .line {
              display: block;
              margin: 0 auto;
              width: 100%;
              height: 2px;
              background-color: #ddd;
            }

            .generate_pdf_question_paper_details {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 20px;
              padding: 16px;
              background: #f9f9f9;
              border: 1px solid #e0e0e0;
              border-radius: 8px;
              font-size: 16px;
              color: #444;
            }

            .generate_pdf_question_paper_details span {
              font-weight: bold;
              color: #333;
            }

            .generate_pdf_question_paper_instructions {
              margin-top: 20px;
              padding: 16px;
              border: 1px solid #e0e0e0;
              background-color: #f9f9f9;
              border-radius: 8px;
            }

            .generate_pdf_question_paper_instructions h3 {
              font-size: 18px;
              font-weight: bold;
              color: #333;
              margin-bottom: 10px;
            }

            .generate_pdf_question_paper_instructions ul {
              padding-left: 20px;
              margin: 0;
            }

            .generate_pdf_question_paper_instructions ul li {
              font-size: 14px;
              color: #555;
              margin-bottom: 5px;
            }

            .generate_pdf_question_paper_generated_pdf_total_question {
              margin-top: 20px;
                max-width:calc(100% - 25px);
                padding-left:0;
                margin-left:auto;
                margin-right:auto;
            }

            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question {
              margin-bottom: 20px;
              font-family: Arial, sans-serif;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question p {
              font-size: 16px;
              font-weight: normal;
              color: #333;
              margin-bottom: 10px;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ol {
              padding-left: 0;
              margin: 0;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ul {
              list-style-type: none;
              margin: 0;
              padding-left: 20px;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ul li {
              font-size: 16px;
              color: #444;
              margin-bottom: 8px;
              padding-left: 35px; /* Adjust space to align with the bubble */
              position: relative;
              line-height: 1.5;
            }

            /* Circle for the option letter */
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ul li:before {
              content: attr(data-option);
              position: absolute;
              left: 0;
              top: 0;
              width: 24px; /* Circle width */
              height: 24px; /* Circle height */
              background-color: transparent; /* Circle background color */
              border: 2px solid #333; /* Circle border */
              border-radius: 50%; /* Makes it a perfect circle */
              display: flex;
              justify-content: center;
              align-items: center;
              font-weight: bold;
              font-size: 14px;
              color: #333; /* Text inside the bubble */
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ul li span {
              font-weight: normal;
              font-size: 16px;
              margin-left: 10px;
              color: #444;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_generated_pdf_total_question ol li {
              font-size: 16px;
              color: #444;
              margin-bottom: 8px;
              line-height: 1.6;
            }
            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ol li:before {
              content: counter(item) '.';
              counter-increment: item;
              position: absolute;
              left: 0;
              top: 0;
              font-weight: normal;
              color: #333;
              font-size: 18px;
              padding-left: 10px;
            }

            .generate_pdf_question_paper_generated_pdf_total_question .generate_pdf_question_paper_question ol {
              counter-reset: item;
            }


            .pdf-question-paper-listed-outer{
              list-style-type: none;
            }
            .pdf-question-paper-listed-outer span.list-number{
              display: inline-block;
              margin-right:10px;
            }
            .generate_pdf_question_paper_generated_pdf_total_question:has(.pdf-question-paper-listed-outer) {
              padding-left: 0px;
              margin: auto;
              max-width: calc(100% - 25px);
            }
            .generate_pdf_question_paper_generated_pdf_total_question .pdf-question-paper-listed-outer:first-child {
              margin-top: 15px;
            }
            .pdf-question-paper-listed-outer {
              margin-top: 20px;
            }
            .pdf-question-paper-listed-outer .card-question-header {
                display: flex;
                align-items: baseline;
            }

            .pdf-question-paper-listed-outer ul.margin-top-10 {
              margin: 10px 0px;
            }
            .pdf-question-paper-listed-outer .pdf-highlight{
              padding-left: 20px;
            }


          }
          </style>
          </head>
          <body style="padding:0;margin:0 auto;">
          ${content.outerHTML}
          </body>
          </html>
        `);

        // Delay to ensure content is written before printing
        setTimeout(() => {
          printWindowReportContent.document.close();
          printWindowReportContent.focus();
          printWindowReportContent.print();
          printWindowReportContent.close();
        }, 250);
      } else if (id === 'AppSubscriptionReport') {
        let printWindowReportContent = window.open(' ', '_blank');
        const newContent = (
          <div class="report_block">
            <div class="heading">
              <div class="logo">
                <img src={VidyaUpasna} alt="VidyaUpasna Logo" />
              </div>
              <div class="text_center">
                <h4>Vidya Upasna</h4>
              </div>
              <div class="logo">
                <img src={"https://api.examninja.co.in/images/1705820792167-939.jpeg"} alt="VidyaUpasna Logo" />
              </div>
            </div>

            <div class="report_code text_center">
              <img src={separator_line} alt="" className="line" />
              <span className="txt">Student Subscription Report</span>
            </div>

            <div class="report_head">
              <span>Section: {title[0]?.studentDetails?.sectionMasterDetails?.sectionName}</span>
              <span>Board: {title[0]?.studentDetails?.sectionMasterDetails?.boardMasterDetails?.boardName}</span>
              <span>Medium: {title[0]?.studentDetails?.sectionMasterDetails?.streamOrMediumMasterDetails?.streamName}</span>
            </div>

            <div class="analysis_report">
              <table>
                <thead>
                  <tr>
                    <th rowSpan="2">Student Name</th>
                    <th rowSpan="2">Gender</th>
                    <th rowSpan="2">Phone</th>
                    <th rowSpan="2">Email</th>
                    <th rowSpan="2">Academic Year</th>
                    <th rowSpan="2">Grade</th>
                    <th rowSpan="2">Division</th>
                    <th colSpan="6">Payment Details</th>
                  </tr>
                  <tr>
                    <th>Order ID</th>
                    {/* <th>Currency</th> */}
                    <th>Receipt</th>
                    <th>Amount</th>
                    <th>Payment ID</th>
                    <th>Payment Status</th>
                    <th>Subscription Type</th>
                  </tr>
                </thead>
                <tbody>
                  {title.map((data, i) =>
                    data.paymentOrderDetails.map((paymentDetail, j) => (
                      <tr key={paymentDetail.id}>
                        {j === 0 && (
                          <>
                            <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.studentName}</td>
                            <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.gender}</td>
                            <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.primaryContact}</td>
                            <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.email}</td>
                            <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.academicYearMasterDetails.yearName}</td>
                            <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.instituteGradeMasterDetails.gradeName}</td>
                            <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.instituteDivisionMasterDetails.divisionName}</td>
                          </>
                        )}
                        <td>{paymentDetail.order_id}</td>
                        {/* <td>{paymentDetail.currency}</td> */}
                        <td>{paymentDetail.receipt}</td>
                        <td>{paymentDetail.amount}</td>
                        <td>{paymentDetail.razor_payment_id}</td>
                        <td>{paymentDetail.payment_status ? "Paid" : "Pending"}</td>
                        <td>
                          {
                            planList?.map(plan => {
                              if (paymentDetail.subscription_type === plan.id) {
                                return plan.subscriptionName
                              }
                            })
                          }
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

          </div>
        )

        printWindowReportContent.document.write(`
          <html>
          <head>
          <style>
            @media print{
              // tr {
              //   page-break-inside: avoid;
              //   break-inside: avoid;
              // }
              @page {
                size: landscape;
              }
              * {
                box-sizing: border-box;
              }
              body {
                margin: 0;
                padding: 0;
                overflow-x: hidden;
              }
              .report_code {
                position: relative;
              }
              .report_code .line {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 0;
                width: 100%;
              }

              table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
                word-wrap: break-word;
              }

              table thead tr th,
              table tbody tr td,
              table tfoot tr th {
                padding: 8px;
                border: 1px solid #000;
                text-align: center;
                vertical-align: middle;
              }

              .exam_report table tbody tr td {
                color: #a80000;
              }

              .table_caption {
                display: block;
                text-align: center;
                font-weight: 600;
                margin: 16px 0;
              }

              .analysis_report table thead tr th,
              .analysis_report table tfoot tr th {
                color: #a80000;
              }

              .text_right {
                text-align: right;
              }

              .text_center {
                text-align: center;
              }

              .report_block .heading {
                display: flex;
                align-items: center;
                justify-content: space-between;
              }

              .report_block .heading .logo {
                width: 100px;
              }

              .report_block .heading .logo img {
                max-width: 100%;
              }

              .report_block .report_code span.txt {
                display: inline-block;
                padding: 8px 20px;
                border-radius: 8px;
                border: 1px solid #000;
                background: #f1f1f1;
                position: relative;
                z-index: 1;
              }

              .report_block .report_head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 32px 0;
                text-align: center;
              }

              .report_block .report_head span {
                display: block;
              }

              .report_block .report_footer {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                margin-top: 24px;
              }

              .report_block .report_footer div {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 16px;
              }

              .report_block .report_footer span {
                display: block;
                color: #a80000;
                font-weight: 500;
                text-align: center !important;
              }

              .candidate_details table tbody tr td {
                text-align: left;
                padding: 24px;
              }
            }
          </style>
          </head>
          <body>
          ${ReactDOMServer.renderToString(newContent)}
          </body>
          </html>
        `);
        // Delay to ensure content is written before printing
        setTimeout(() => {
          printWindowReportContent.document.close();
          printWindowReportContent.focus();
          printWindowReportContent.print();
          printWindowReportContent.close();
        }, 250);
      } else if (id === 'subscriberList') {
        const studentDetails = title?.studentList;
        const InstituteMaster = title?.InstituteMaster;
        const studentContent = (
          <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" className='sl_no'>Sr. No.</th>
                  <th scope="col">User Name</th>
                  <th scope="col">Email </th>
                </tr>
              </thead>
              <tbody>
                {
                  studentDetails?.length > 0 ?
                    studentDetails?.map((data, index) => {
                      return (
                        <tr>
                          <th scope="row" className='sl_no'>{index + 1}</th>
                          <td>{data.userUniqueId}</td>
                          <td>{data.email}</td>
                        </tr>
                      )
                    })
                    :
                    (<tr>
                      <th colspan={"100%"} style={{ textAlign: 'center' }}>No Students Available</th>
                    </tr>)
                }
              </tbody>
            </table>
          </div>
        )

        // const newContent = `
        //   <div>
        //     <div class="heading">
        //       <div class="logo">
        //           <img src=${teacherDetails[0]?.teacher?.instituteMasterDetails?.logoPath} alt="Logo" />
        //       </div>

        //       <div class="text_center">
        //           <h6>${teacherDetails[0]?.teacher?.instituteMasterDetails?.instituteName}</h6>
        //           <h4>${teacherDetails[0]?.teacher?.sectionMasterDetails?.sectionName}</h4>
        //           <h3>${headerTitle}</h3>
        //       </div>
        //       <div class="logo">
        //           <img src=${teacherDetails[0]?.teacher?.sectionMasterDetails?.logoPath} alt="Logo" />
        //       </div>
        //     </div>
        //     ${ReactDOMServer.renderToString(teacherContent)}
        //   </div>
        // `;

        const newContent = `
          <div>
            <div class="heading">
              <div class="logo">
                ${VidyaUpasna ?
            `<img src="${VidyaUpasna}" alt="Logo" />` : ''
          }
              </div>
              
              <div class="text_center">
                <h6>VidyaUpasna</h6>
                <h4>${InstituteMaster?.instituteName}</h4>
                <h3>${headerTitle === "incomplete" ? "Incomplete Subscription Student List" : "Complete Subscription Student List"}</h3>
              </div>
              
              <div class="logo">
                ${InstituteMaster?.logoPath ?
            `<img src="${InstituteMaster?.logoPath}" alt="Logo" />` : ''
          }
              </div>
            </div>
            ${ReactDOMServer.renderToString(studentContent)}
          </div>
        `;

        let printWindowTableContent = window.open(' ', '_blank');

        printWindowTableContent.document.write(`
          <html>
          <head>
          <style>
            @media print {
              body {
                margin: 0;
                padding: 0;
                font-size: 12px;
                color: #000; /* Ensure text is black for high contrast */
              }
        
              .heading {
                display: flex;
                align-items: center;
                justify-content: center;
                background: #004580;
                padding: 10px;
                border-radius: 20px 20px 0 0;
                width: 100%;
                box-sizing: border-box;
                margin-bottom: 0;
                color: #fff; /* Ensure text is white for contrast */
                font-weight: bold; /* Make header text bold */
              }
        
              .heading .text_center h3 {
                // margin: 0;
                // text-align: center;
                font-size: 2.5em;
                // flex-grow: 1;
              }

              .heading .text_center h6, h4 {
                margin: 0;
                font-size: 1.5em;
                // text-align: center;
                // font-size: 2.5em;
                // flex-grow: 1;
              }

              .text_center {
                margin: 0;
                text-align: center;
                flex-grow: 1;
              }
        
              .heading .logo {
                width: 100px;
                flex-shrink: 0;
              }
        
              .heading .logo img {
                max-width: 100%;
                border-radius: 15px;
              }
        
              table {
                border-collapse: collapse;
                width: 100%;
                margin: 0;
              }
        
              table thead tr th {
                background-color: #004580 !important;
                color: #fff !important;
                border-width: 1px;
                padding: 10px;
                vertical-align: middle;
                border-color: #333; /* Darker border color */
                border-style: solid;
                font-weight: bold; /* Make table header text bold */
              }
        
              table tbody tr td,
              table tbody tr th {
                border-width: 1px;
                padding: 10px;
                vertical-align: middle;
                border-color: #333; /* Darker border color */
                color: #000; /* Ensure text color is black for clarity */
                border-style: solid;
              }
        
              table tr tbody td.sl_no,
              table tr thead th.sl_no {
                min-width: 50px;
                width: 50px;
              }
        
              @page {
                size: landscape;
                margin: 10mm; /* Add some margin to avoid cutting off content */
              }
            }
          </style>
          </head>
          <body>
            ${newContent}
          </body>
          </html>
        `);

        setTimeout(() => {
          printWindowTableContent.document.close();
          printWindowTableContent.focus();
          printWindowTableContent.print();
          printWindowTableContent.close();
        }, 250);
      }
    } else {
      console.error(`Element with id '${id}' not found.`);
    }
  }

  return (
    <div className="export-container">
      <button className="print-btn btn btn-info" onClick={exportToPdf}>
        Export <i className="fa-solid fa-file-pdf"></i>
      </button>
    </div>
  );
};